<div id="ng-content" [style.transform]="isDrawerOpen ? 'translateX(245px)' : null">
  <div class="page-wrapper" [class.page-wrapper-rtl]="direction === 'rtl'" [dir]="direction">
    <app-header
      [windowWidth]="windowWidth"
      [page]="page"
      [(language)]="language"
      (languageChange)="switchLanguage($event)"
      (versionChange)="navigateToVersion($event)"
      (directionChange)="switchDirection($event)"
    ></app-header>
    <div class="main-wrapper">
      <div mwc-row>
        <div
          mwc-col
          *ngIf="!showDrawer"
          [mwcXs]="24"
          [mwcSm]="24"
          [mwcMd]="6"
          [mwcLg]="6"
          [mwcXl]="5"
          [mwcXXl]="4"
          class="main-menu"
        >
          <mwc-affix [mwcOffsetTop]="0">
            <section class="main-menu-inner">
              <ng-template [ngTemplateOutlet]="sideOrDrawerTpl"></ng-template>
            </section>
          </mwc-affix>
        </div>
        <div
          mwc-col
          class="main-container main-container-component"
          [mwcXs]="24"
          [mwcSm]="24"
          [mwcMd]="18"
          [mwcLg]="18"
          [mwcXl]="19"
          [mwcXXl]="20"
        >
          <router-outlet></router-outlet>
          <!-- <mwc-contributors-list></mwc-contributors-list> -->
        </div>
      </div>
      <div mwc-row>
        <div
          mwc-col
          [mwcXs]="{ span: 24 }"
          [mwcSm]="{ span: 24 }"
          [mwcMd]="{ span: 24 }"
          [mwcLg]="{ span: 18, offset: 6 }"
          [mwcXl]="{ span: 19, offset: 5 }"
          [mwcXXl]="{ span: 20, offset: 4 }"
        >
          <app-fixed-widgets
            [theme]="theme"
            (themeChange)="onThemeChange($event)"
            [language]="language"
          ></app-fixed-widgets>
          <mwc-nav-bottom></mwc-nav-bottom>
          <app-footer
            [colorHex]="color"
            [language]="language"
            (colorChange)="changeColor($event)"
          ></app-footer>
        </div>
      </div>
    </div>
  </div>
</div>

<div class="drawer-wrapper" *ngIf="showDrawer">
  <div class="drawer drawer-left" [class.drawer-open]="isDrawerOpen">
    <div class="drawer-mask" (click)="isDrawerOpen = false"></div>
    <div
      class="drawer-content-wrapper"
      [style.transform]="isDrawerOpen ? null : 'translateX(-100%)'"
    >
      <div class="drawer-content">
        <ng-container [ngTemplateOutlet]="sideOrDrawerTpl"></ng-container>
      </div>
      <div class="drawer-handle" (click)="isDrawerOpen = !isDrawerOpen">
        <span class="drawer-handle-icon"></span>
      </div>
    </div>
  </div>
</div>

<ng-template #sideOrDrawerTpl>
  <app-side
    [direction]="direction"
    [page]="page"
    [routerList]="routerList"
    [language]="language"
  ></app-side>
</ng-template>
